import { IClassname } from '@/lib/shared/model/classname';

export const Terrace = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.30396 6.0957L2.31095 13.1434C2.49124 14.4069 2.58177 15.6817 2.58187 16.958C2.5817 19.0812 2.34945 21.1981 1.88924 23.2709L1.30396 25.9034"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.58179 16.958H8.97137C9.3103 16.958 9.63534 17.0926 9.87499 17.3323C10.1147 17.572 10.2493 17.897 10.2493 18.2359V25.9034"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 25.2652V13.125"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33252 13.125H23.6675"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8052 25.9043H19.1948"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.4182 16.958H23.0287C22.6897 16.958 22.3647 17.0926 22.125 17.3323C21.8854 17.572 21.7507 17.897 21.7507 18.2359V25.9034"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6961 6.0957L29.6891 13.1434C29.5088 14.4069 29.4183 15.6817 29.4182 16.958C29.4184 19.0812 29.6506 21.1981 30.1108 23.2709L30.6961 25.9034"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
